import React from 'react';
import {SimpleTextIconWrapper, SimpleTextInputWrapper} from "./input.styles";

const SimpleTextInput = ({label, classNames, icon: Icon, ...otherProps}) => {
    return (
        <SimpleTextInputWrapper inputValue={otherProps.value} className={classNames}>
            <label className='mb-2'>{label}</label>
            <input {...otherProps} />
            {
                Icon && <SimpleTextIconWrapper>
                    {Icon}
                </SimpleTextIconWrapper>
            }
        </SimpleTextInputWrapper>
    );
};

export default SimpleTextInput;
